import React from 'react';

const BrandBadge = ({ 
  brand, 
  size = 'sm', 
  className = '',
  onClick,
  title
}) => {
  // Handle both brand object and legacy string format
  const brandName = typeof brand === 'string' ? brand : brand?.nombre || 'Sin marca';
  const brandColor = typeof brand === 'string' ? '#6B7280' : brand?.color || '#6B7280';
  
  // Size variations for text display (original design)
  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };
  
  const badgeClasses = `
    font-medium
    ${sizeClasses[size]}
    ${onClick ? 'cursor-pointer hover:opacity-70 transition-opacity' : ''}
    ${className}
  `.trim();
  
  return (
    <span 
      className={badgeClasses}
      style={{ color: brandColor }}
      onClick={onClick}
      title={title || brandName}
    >
      {brandName}
    </span>
  );
};

export default BrandBadge;